import { createContext } from 'react';

import { A11yToolbarTabIndex } from '../types/toolbar.js';

export const A11yToolbarTabIndexContext = createContext<A11yToolbarTabIndex[]>(
  [],
);

A11yToolbarTabIndexContext['displayName'] = 'A11yToolbarTabIndexContext';
